import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { DonorService } from '../../services/donor.service';
import { DonorsApiActions, DonorsPageActions } from './donors.actions';

@Injectable()
export class DonorsEffects {
  private readonly actions$ = inject(Actions);
  private readonly donorService = inject(DonorService);

  readonly loadDonors$ = createEffect(() => this.actions$.pipe(
    ofType(DonorsPageActions.opened, DonorsPageActions.filtersChanged),
    switchMap((action) => {
      const filters = 'filters' in action ? action.filters : undefined;
      return this.donorService.getAll(filters).pipe(
        map((donors) => DonorsApiActions.loadSucceeded({ donors })),
        catchError((error: { message?: string }) => of(DonorsApiActions.loadFailed({
          error: error?.message ?? 'Unable to load donors',
        }))),
      );
    }),
  ));
}